import { CircularProgress, makeStyles, TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { debounce } from "lodash";
import React from "react";
import { useCallback, useEffect, useState } from "react";
import { useDataProvider, useInput, useNotify } from "react-admin";
import { useField } from "react-final-form";

const useStyles = makeStyles({
  root: {
    marginTop: "8px",
    paddingBottom: "3px",
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#EAEAEA",
      },
      "&:hover fieldset": {
        borderColor: "#EAEAEA",
      },
    },
  },
});

export default function InvoiceInCreditNoteInput(props: any) {
  const [customerLedgers, setCustomerLedgers] = useState<string[]>([]);
  const [parent, setParent] = useState<IParent>();
  const provider = useDataProvider();
  const notify = useNotify();
  const [loading, setLoading] = useState<boolean>(false);
  const [invoiceText, setInvoiceText] = useState("");

  const classes = useStyles();
  const parentId = useField("parentId");

  const {
    input: { onChange },
  } = useField("invoiceNo");

  const { options, ...rest } = props;

  const {
    input,
    meta: { touched, error },
  } = useInput(rest);

  const getParent = (parentId: number) => {
    provider
      .getOne(props.personType, {
        id: parentId,
      })
      .then(({ data }) => {
        setParent(data as any);
      });
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const callInvoiceListApi = useCallback(
    debounce((searchVal: string, customerAccountingId: string) => {
      const filter = JSON.stringify({
        CustomerId: customerAccountingId,
        Status: "Posted",
      });

      provider
        .customGetListWithStaticParams(
          `invoices?pageSize=50&search=${searchVal}&filter=${filter}`
        )
        .then(({ data }: any) => {
          if (data.length > 0) {
            setCustomerLedgers(
              data.map(
                (item: any) =>
                  `${item.id} - ${item.number} - ${item.items[0].description}`
              )
            );
            setLoading(false);
          } else {
            setCustomerLedgers([]);
            setLoading(false);
          }
        })
        .catch((error: any) => {
          notify(`Error from Accounting : ${error.message}`, "error");
          setCustomerLedgers([]);
          setLoading(false);
        });
    }, 1000),
    [parent]
  );

  useEffect(() => {
    if (parent === undefined) {
      getParent(parentId.input.value);
    } else {
      setLoading(true);
      callInvoiceListApi(input.value, parent.user.accountingCustomerId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [input.value, parentId.input.value, parent]);

  return (
    <Autocomplete
      className={classes.root}
      freeSolo
      options={customerLedgers}
      onChange={(event, newValue, reason) => {
        if (reason === "select-option") {
          const splitedValue = newValue.split(" ");
          input.onChange(splitedValue[0]);
          onChange(splitedValue[0]);
          setInvoiceText(splitedValue[2]);
        }

        if (reason === "clear") {
          input.onChange(null);
          onChange(null);
        }

        if (newValue === null) {
          input.onChange(null);
          onChange(null);
        }
      }}
      value={invoiceText}
      loading={loading}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          label={props.label}
          error={!!(touched && error)}
          helperText={touched && error}
          {...input}
          InputProps={{
            ...params.InputProps,
            // type: "search",
            endAdornment: (
              <React.Fragment>
                {loading ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
              </React.Fragment>
            ),
          }}
        />
      )}
    />
  );
}
